import React from 'react';
import { PROFILE } from '../Pages';

export default {
  path: PROFILE.pageURL,
  async action() {
    const { default: Profile } = await import('./Profile');
    return <Profile key={'profile'} />;
  },
};
